import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/imgs/vul-scan.svg';
import _imports_1 from '@/assets/img/imgs/memberbiao.svg';
import _imports_2 from '@/assets/img/imgs/paypal.png';

const _withScopeId = n => (_pushScopeId("data-v-0d19fa87"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "title1"
};
const _hoisted_2 = {
  class: "font16 label-color text-capitalize"
};
const _hoisted_3 = {
  key: 0,
  class: "fr"
};
const _hoisted_4 = {
  class: "colorMain font16"
};
const _hoisted_5 = {
  class: "colorMain font16"
};
const _hoisted_6 = {
  class: "orderForm"
};
const _hoisted_7 = {
  class: "title2"
};
const _hoisted_8 = {
  class: "shopCart"
};
const _hoisted_9 = {
  class: "title2"
};
const _hoisted_10 = {
  class: "shopCartBox"
};
const _hoisted_11 = {
  class: "shopCartList"
};
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "iconImg fl"
};
const _hoisted_14 = {
  key: 0,
  src: _imports_0,
  loading: "lazy"
};
const _hoisted_15 = {
  key: 1,
  src: _imports_1,
  loading: "lazy"
};
const _hoisted_16 = {
  class: "fl ml20 info_"
};
const _hoisted_17 = {
  class: "edition-name text-capitalize"
};
const _hoisted_18 = {
  key: 0,
  class: "edition-info"
};
const _hoisted_19 = {
  key: 1,
  class: "edition-info"
};
const _hoisted_20 = {
  key: 1
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode("   ");

const _hoisted_22 = {
  key: 0,
  class: "error2-color font12"
};
const _hoisted_23 = {
  key: 1,
  class: "error2-color font12"
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  class: "discount"
};
const _hoisted_26 = {
  key: 0
};
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = {
  key: 2
};
const _hoisted_29 = {
  class: "total"
};
const _hoisted_30 = {
  class: "pay"
};
const _hoisted_31 = {
  class: "title2"
};
const _hoisted_32 = {
  class: "payUl"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["src"];

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_37 = {
  key: 0,
  class: "payHint"
};

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_39 = {
  class: "next"
};
const _hoisted_40 = {
  key: 0,
  class: "verifyOrderForm"
};
const _hoisted_41 = {
  class: "title2"
};
const _hoisted_42 = {
  class: "shopCart"
};
const _hoisted_43 = {
  class: "title2"
};
const _hoisted_44 = {
  class: "shopCartBox"
};
const _hoisted_45 = {
  class: "shopCartList"
};
const _hoisted_46 = {
  class: "info"
};
const _hoisted_47 = {
  class: "iconImg fl"
};
const _hoisted_48 = {
  key: 0,
  src: _imports_0,
  loading: "lazy"
};
const _hoisted_49 = {
  key: 1,
  src: _imports_1,
  loading: "lazy"
};
const _hoisted_50 = {
  class: "fl ml20 info_"
};
const _hoisted_51 = {
  class: "edition-name text-capitalize"
};
const _hoisted_52 = {
  key: 0,
  class: "edition-info"
};
const _hoisted_53 = {
  key: 1,
  class: "edition-info"
};
const _hoisted_54 = {
  class: "num"
};
const _hoisted_55 = {
  class: "input_number"
};
const _hoisted_56 = {
  class: "period"
};
const _hoisted_57 = {
  key: 0,
  class: "input_number"
};
const _hoisted_58 = {
  key: 1
};
const _hoisted_59 = {
  class: "total"
};
const _hoisted_60 = {
  class: "pay"
};
const _hoisted_61 = {
  class: "title2"
};
const _hoisted_62 = {
  class: "paMethod"
};
const _hoisted_63 = {
  key: 0,
  src: _imports_2
};
const _hoisted_64 = {
  class: "next"
};
const _hoisted_65 = {
  class: "agreement"
};
const _hoisted_66 = {
  key: 1,
  class: "emphasize"
};
const _hoisted_67 = {
  key: 1,
  class: "btn-tips"
};
const _hoisted_68 = {
  key: 0
};
const _hoisted_69 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_orderFormItem = _resolveComponent("orderFormItem");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_verifyOrderForm = _resolveComponent("verifyOrderForm");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Payment Details")), 1), _createElementVNode("span", _hoisted_2, "  ( " + _toDisplayString(_ctx.$t(_ctx.licenseDetail.name)) + " ) ", 1), _ctx.active == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_ctx.oneYuan === '0' && _ctx.edition != '16' ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: "/chat/15"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Buy Enterprise Edition")), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.oneYuan === '1' || _ctx.edition == '16' ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.init(true))
  }, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("Buy Red Team Edition")), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("Personal Details")), 1), _createVNode(_component_orderFormItem, {
    ref: "orderFormItem",
    "one-yuan": _ctx.oneYuan,
    class: "orderFormItem"
  }, null, 8, ["one-yuan"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("Your shopping cart")), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_ctx.edition == '16' ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : (_openBlock(), _createElementBlock("img", _hoisted_15))]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.licenseDetail.name), 1), _ctx.oneYuan === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.getCurrencySymbol()) + " " + _toDisplayString(_ctx.formatPrice(_ctx.price)) + " / " + _toDisplayString(_ctx.$t("computer")) + " X " + _toDisplayString(_ctx.periods || 0), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.getCurrencySymbol()) + " " + _toDisplayString(_ctx.formatPrice(_ctx.price)) + " / " + _toDisplayString(_ctx.$t("computer")) + " X 1 ", 1))])]), _createElementVNode("div", {
    class: _normalizeClass(["num_info", {
      'ac': _ctx.oneYuan === '1'
    }])
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Number of users")), 1), _ctx.oneYuan === '0' ? (_openBlock(), _createBlock(_component_el_input, {
    key: 0,
    type: "text",
    modelValue: _ctx.num,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.num = $event),
    class: "input_number width80",
    onInput: _ctx.numChange
  }, null, 8, ["modelValue", "onInput"])) : (_openBlock(), _createElementBlock("span", _hoisted_20, "1"))], 2), _createElementVNode("div", {
    class: _normalizeClass(["period_info", {
      'ac': _ctx.oneYuan === '1'
    }])
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Subscription Option")), 1), _ctx.oneYuan === '0' ? (_openBlock(), _createBlock(_component_el_select, {
    key: 0,
    modelValue: _ctx.periods,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.periods = $event),
    "allow-create": "",
    "default-first-option": "",
    "reserve-keyword": false,
    class: "input_number width160 align-left",
    placeholder: "",
    onChange: _ctx.orderPerAdds
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodsList, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.period,
        label: item.label,
        value: item.period
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.label), 1), _hoisted_21, item.description && _ctx.lang == 'en' ? (_openBlock(), _createElementBlock("span", _hoisted_22, " ( " + _toDisplayString(item.description) + " ) ", 1)) : _createCommentVNode("", true), item.description_cn && _ctx.lang == 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_23, " ( " + _toDisplayString(item.description_cn) + " ) ", 1)) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])) : (_openBlock(), _createElementBlock("span", _hoisted_24, "7 " + _toDisplayString(_ctx.$t('days')), 1)), _createElementVNode("div", _hoisted_25, [_ctx.discount ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('Save')) + " " + _toDisplayString(_ctx.getCurrencySymbol()) + " " + _toDisplayString(_ctx.formatPrice(_ctx.discount)), 1)) : _createCommentVNode("", true), _ctx.discount && _ctx.period_day ? (_openBlock(), _createElementBlock("span", _hoisted_27, "   ")) : _createCommentVNode("", true), _ctx.period_day ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.discount ? _ctx.$t('Extra') : _ctx.$t('Given')) + " " + _toDisplayString(_ctx.period_day) + " " + _toDisplayString(_ctx.$t('days')), 1)) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("total")) + ": " + _toDisplayString(_ctx.getCurrencySymbol()) + " " + _toDisplayString(_ctx.formatPrice(_ctx.total)), 1)])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("Please select your payment method.")), 1), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payList, (name, key, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["payList pointer", {
        currPayList: _ctx.pay == key
      }]),
      onClick: $event => _ctx.setPay(key),
      key: index
    }, [_createElementVNode("img", {
      src: require(`@/assets/img/imgs/${key}.png`),
      alt: ""
    }, null, 8, _hoisted_34), _hoisted_35, _createElementVNode("span", null, _toDisplayString(name), 1)], 10, _hoisted_33);
  }), 128))]), _hoisted_36, _ctx.local.locale === 'en' && _ctx.pay === 'paypal' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("We will redirect you to a secure third-party service where you can pay with PayPal.")), 1)])) : _createCommentVNode("", true), _hoisted_38]), _createElementVNode("div", _hoisted_39, [_createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.verify(0)),
    class: "pointer"
  }, _toDisplayString(_ctx.$t("Next Step")), 1)])], 512), [[_vShow, _ctx.active == 0]]), _ctx.active == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createTextVNode(_toDisplayString(_ctx.$t("Check your profile")) + " ", 1), _createElementVNode("i", {
    class: "iconfont icon-Submit-01 pointer",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.changeActive(0))
  })]), _createVNode(_component_verifyOrderForm, {
    form: _ctx.formData,
    "one-yuan": _ctx.oneYuan
  }, null, 8, ["form", "one-yuan"]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createTextVNode(_toDisplayString(_ctx.$t("Your shopping cart")) + " ", 1), _createElementVNode("i", {
    class: "iconfont icon-Submit-01 pointer",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.changeActive(0))
  })]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_ctx.edition == '16' ? (_openBlock(), _createElementBlock("img", _hoisted_48)) : (_openBlock(), _createElementBlock("img", _hoisted_49))]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.licenseDetail.name), 1), _ctx.oneYuan === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.getCurrencySymbol()) + " " + _toDisplayString(_ctx.formatPrice(_ctx.price)) + " / " + _toDisplayString(_ctx.$t("computer")) + " X " + _toDisplayString(_ctx.periods), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.getCurrencySymbol()) + " " + _toDisplayString(_ctx.formatPrice(_ctx.price)) + " / " + _toDisplayString(_ctx.$t("computer")) + " X 1 ", 1))])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Number of users")) + "   ", 1), _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.num), 1)]), _createElementVNode("div", _hoisted_56, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("Subscription Option")) + "   ", 1), _ctx.oneYuan === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.periods), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_58, "7 " + _toDisplayString(_ctx.$t('days')), 1))]), _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("total")) + ": " + _toDisplayString(_ctx.getCurrencySymbol()) + _toDisplayString(_ctx.formatPrice(_ctx.total)), 1)])])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createTextVNode(_toDisplayString(_ctx.$t("your payment method.")) + " ", 1), _createElementVNode("i", {
    class: "iconfont icon-Submit-01 pointer",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.changeActive(0))
  })]), _createElementVNode("div", _hoisted_62, [_ctx.pay == 'PayPal' ? (_openBlock(), _createElementBlock("img", _hoisted_63)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.payList[_ctx.pay]), 1)])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("button", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.verify(1)),
    class: "pointer"
  }, _toDisplayString(_ctx.$t("Immediate payment")), 1)]), _createElementVNode("div", _hoisted_65, [_ctx.oneYuan === '1' ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.agreement = $event),
    type: "checkbox",
    class: "pointer",
    id: "agreement",
    name: "agreement"
  }, null, 512)), [[_vModelCheckbox, _ctx.agreement]]) : _createCommentVNode("", true), _ctx.oneYuan === '1' ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$t("Limited to one purchase per person, activation is valid within 7 days.")), 1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_ctx.$t("Agree and know")) + " ", 1), _createElementVNode("span", {
    class: "pointer",
    onClick: _cache[9] || (_cache[9] = $event => _ctx.toPage('/agreement'))
  }, "《" + _toDisplayString(_ctx.$t("Goby user registration and service agreement")) + "》 ", 1)])])) : _createCommentVNode("", true), _ctx.oneYuan === '1' ? (_openBlock(), _createElementBlock("p", _hoisted_67, [_ctx.local.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_68, "温馨提示：1 元试用，仅支持 " + _toDisplayString(_ctx.subDate(30)) + " 前更新的漏洞", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.$t('Notice: Apply for $1 trial, only possess vulnerabilities updated before') + " " + _ctx.subDate(30)), 1))])) : _createCommentVNode("", true)], 64);
}